/** @jsx jsx */
import { jsx } from '@emotion/core';
import { get } from 'lodash';
import { keyColors } from '../../../styles/colors';
import { Column, Container, Row } from '../../../styles/Grid';

import { SafePureComponent } from '../../../utils/SafePureComponent';
import createButtonCss from '../../ui/Button/Button';
import DotComponent from '../../ui/DotComponent';
import Spacer from '../../ui/Spacer';
import * as Styles from './index.styles';

import { browseresionContainer } from './index.styles';

class BrowseRegion extends SafePureComponent {
  safeRender() {
    const { fields } = this.props;
    const title = get(
      fields,
      'title.value',
      'Find an office space wherever you need',
    );
    const Desc = get(
      fields,
      'desc.value',
      'With our national and local networks, we can help you find the best office space for your business.',
    );
    const CtaLink = get(fields, 'link.value', '');
    const CtaText = get(fields, 'CtaText.value', 'BROWSE REGIONS');

    return (
      <Spacer
        backgroundColor={keyColors.brown10}
        marginCss={Styles.containerMarginCss}
        paddingCss={Styles.containerPaddingCss}
      >
        <Container className={Styles.backgroundCircle}>
          <Row css={browseresionContainer}>
            <Column cols={{ sm: 12, md: 8, lg: 8 }}>
              <div className="textArea">
                <h2>
                  {title}
                  <DotComponent />
                </h2>
                <p>{Desc}</p>
              </div>
            </Column>
            <Column className="ctabtn" cols={{ sm: 12, md: 4, lg: 4 }}>
              <div>
                <a
                  className="ctabutton"
                  href={CtaLink}
                  css={[createButtonCss()]}
                >
                  {CtaText}
                </a>
              </div>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

BrowseRegion.displayName = 'Browse Region';

export default BrowseRegion;
